import {
	SET_FORM_STATE,
	SET_METADATA,
	SET_SITES,
	SET_CELLS,
	SET_SERIES,
	SET_LOADING,
	RESET_SERIES
} from '../actions/KPIsOverviewActions';

import {
	GRANULARITIES,
	TECHNOLOGIES,
	CATALOGUE,
	DEFAULT_TECHNOLOGY,
	DEFAULT_GRANULARITY,
	DEFAULT_AGGREGATION_LEVEL
} from '../requests/KPIsOverviewCatalogue';

const initialState = {
	formState: {
		isValid: false,
		values: {
			granularity: DEFAULT_GRANULARITY,
			technology: DEFAULT_TECHNOLOGY,
			/*
			 * Niveis de agregacao passam a ser VARIOS. O resultado agrupa pela
			 * combinacao escolhida: {site, sector} da "10025, 2"; so {sector}
			 * da "2", "3", etc. Comeca com um unico nivel (site).
			 */
			aggregationLevels: [DEFAULT_AGGREGATION_LEVEL],
			siteIds: [],
			/*
			 * Filtro OPCIONAL de celulas. Vazio = todas as celulas dos sites
			 * escolhidos. So e preenchido depois do primeiro Apply, a partir da
			 * lista devolvida por GetCells.
			 */
			cellIds: [],
			kpiIds: [],
			/*
			 * Modo de gráfico:
			 *   'separate' -> um gráfico por KPI (comportamento original);
			 *   'dual'     -> UM gráfico com dois eixos Y, comparando o KPI
			 *                 primário (y1KpiId) com o secundário (y2KpiId).
			 * y1/y2 só são usados em modo 'dual'.
			 */
			chartMode: 'separate',
			y1KpiId: null,
			y2KpiId: null,
			startDate: null,
			endDate: null,
			workDay: null
		},
		touched: {},
		errors: {}
	},

	/*
	 * Comeca com o catalogo local para o ecra nunca aparecer vazio, e e
	 * substituido pela resposta de GetMetadata assim que ela chega.
	 */
	metadata: {
		granularities: GRANULARITIES,
		technologies: TECHNOLOGIES,
		catalogue: CATALOGUE
	},

	sites: [],

	/*
	 * Lista de celulas dos sites escolhidos e a marca da combinacao que a
	 * gerou (tecnologia|granularidade|sites). Serve para nao voltar a pedir
	 * GetCells quando so mudaram filtros que nao afectam a lista (KPIs,
	 * niveis, seleccao de celulas).
	 */
	cells: [],
	cellsKey: null,

	/*
	 * Marcas para nao repetir pedidos que ja foram feitos. Sem isto, cada
	 * montagem do componente voltava a pedir o catalogo e a lista de sites, e
	 * cada resposta criava objectos novos no estado, o que provocava novo
	 * render -- um ciclo que nunca parava.
	 */
	metadataLoaded: false,
	sitesKey: null,

	result: {
		granularity: null,
		technology: null,
		aggregationLevels: [],
		buckets: [],
		series: [],
		warnings: []
	},
	hasResult: false,
	isLoading: false
};

const kpisOverviewReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_FORM_STATE: {
			return {
				...state,
				formState: { ...state.formState, ...action.formState }
			};
		}
		case SET_METADATA: {
			return {
				...state,
				metadata: { ...state.metadata, ...action.metadata },
				metadataLoaded: true
			};
		}
		case SET_SITES: {
			return {
				...state,
				sites: action.sites,
				sitesKey: action.sitesKey
			};
		}
		case SET_CELLS: {
			return {
				...state,
				cells: action.cells,
				cellsKey: action.cellsKey
			};
		}
		case SET_SERIES: {
			return {
				...state,
				result: { ...initialState.result, ...action.result },
				hasResult: true
			};
		}
		case SET_LOADING: {
			return {
				...state,
				isLoading: action.isLoading
			};
		}
		case RESET_SERIES: {
			return {
				...state,
				result: initialState.result,
				hasResult: false
			};
		}
		default: {
			return state;
		}
	}
};

export default kpisOverviewReducer;
